export default __webpack_public_path__ + "static/media/nomEditIcon.c4aa63ff.svg";